export default defineNuxtPlugin(() => {
  const { execute } = useCandidateWriteReliability();

  return {
    provide: {
      candidateWriteReliably: execute,
    },
  };
});
